import React from "react";
import { Typography, Box } from "@mui/material";
import Stack from "@mui/material/Stack";
import MzCheckbox from "@markaaz/ui/MzCheckbox";
import MzAlert from "@markaaz/ui/MzAlert";

const sx = {
  checkbox: (theme) => ({
    "& .MuiTypography-root": {
      ...theme.typography.body1,
      paddingLeft: "10px"
    },
    "& .MuiCheckbox-root": {
      color: theme.palette.darkBlue.c50
    },
    "& .Mui-checked": {
      color: theme.palette.blue.c100
    },
    paddingLeft: "20px",
    "&.Mui-disabled": {
      "& .MuiCheckbox-root": {
        color: theme.palette.darkBlue.c20
      },
      "& .MuiFormControlLabel-label": {
        color: theme.palette.darkBlue.c50
      }
    }
  })
};

function MatchConfiguration({
  checkBoxValues,
  permissions,
  showAlert,
  onDisabledSection,
  onAlertClose,
  onCheckBoxChange
}) {
  return (
    <Box>
      <Box p={5}>
        <Typography variant="body1M" color="blue.c100">
          Advanced Match Features
        </Typography>
        <Typography mt={1} mb={4} variant="body2">
          Select whether or not to show advanced matching features. Grades which indicate how strong a match is on a
          letter scale. If you choose not to show grades, the metadata will appear empty. If you choose to show grades
          your contracted rate for the additional data shall apply.
        </Typography>
        <Box sx={{ display: "flex" }}>
          <Stack onClick={!permissions.advancedMatchFeatures ? () => onDisabledSection("matching") : null}>
            <MzCheckbox
              label="Show Grades"
              name="showGrades"
              sx={sx.checkbox}
              checked={checkBoxValues.showGrades}
              disabled={!permissions.advancedMatchFeatures}
              onChange={onCheckBoxChange}
            ></MzCheckbox>
            <MzCheckbox
              label="Show Non-Matches"
              name="showNonMatches"
              sx={sx.checkbox}
              checked={checkBoxValues.showNonMatches}
              disabled={!permissions.advancedMatchFeatures}
              onChange={onCheckBoxChange}
            ></MzCheckbox>
          </Stack>
          {showAlert.matching && (
            <MzAlert
              severity={"error"}
              sx={{ maxWidth: "400px", maxHeight: "72px", alignItems: "center" }}
              onClose={() => {
                onAlertClose("matchConfig");
              }}
            >
              Your account is not currently contracted for Advanced Matching. To change contract terms, contact your
              account manager.
            </MzAlert>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default MatchConfiguration;
